const {
	findOptionalArgument,
	findArguments,
	makeMathCommandNode,
} = require("../util/ParserHelpers");

const variants = ["normal", "highlight", "invalid"];
const turnbotCommands = ["f", "b", "cw", "ccw"];
const orthobotCommands = ["n", "s", "e", "w"];
const orthobotXOffsets = {
	n: 0,
	s: 0,
	e: -0.3,
	w: 0.3,
};
const commands = [...turnbotCommands, ...orthobotCommands];
const buttonCommands = [...commands, "scroll-left", "scroll-right"];

const botButtonParser = function(ps) {
	const reqArgs = findArguments(ps, 1);
	if (!reqArgs) {
		ps.pushError("botButton requires a command");
		return false;
	}

	const command = reqArgs[0].text;

	if (!buttonCommands.includes(command)) {
		ps.pushError(
			`botButton command must be one of ${buttonCommands.join(",")}`
		);
		return false;
	}

	return {
		type: "botImage",
		name: `button/button-${command}`,
	};
};

const botIconParser = function(ps) {
	const optArg = findOptionalArgument(ps);
	const reqArgs = findArguments(ps, 2);

	if (!reqArgs) {
		ps.pushError("botIcon requires a command and content");
		return false;
	}

	const variant = optArg ? optArg.text : "normal";

	if (!variants.includes(variant)) {
		ps.pushError(`optional arg variant must be one of ${variants.join(",")}`);
		return false;
	}

	const command = reqArgs[0].text;

	if (!commands.includes(command)) {
		ps.pushError(`command must be one of ${commands.join(",")}`);
		return false;
	}

	let aspectRatio;
	let offsetY = 0,
		offsetX = 0;
	let scale = 1.35;

	if (turnbotCommands.includes(command)) {
		aspectRatio = {
			w: 64,
			h: 71,
		};
		offsetY = 0.5;
	} else if (orthobotCommands.includes(command)) {
		aspectRatio = {
			w: 58,
			h: 62,
		};
		scale = 1.45;
		offsetX = orthobotXOffsets[command];
	}

	const contentChild = makeMathCommandNode("math", [reqArgs[1]], {
		offsetY,
	});
	const sprite = {
		type: "botImage",
		name: `icon/${command}-${variant}`,
		scale,
		aspectRatio,
		offsetX,
		offsetY,
		children: [...contentChild],
	};

	return [
		{
			type: "overlay",
			children: [sprite],
		},
	];
};

module.exports = {
	parsers: {
		mathCommands: {
			botIcon: botIconParser,
			botButton: botButtonParser,
		},
	},
};
